import type {ReactElement} from 'react';
import React from 'react';
import {VersionHistoryListItem} from '@Components/version-history-list/components/version-history-list-item';
import {VersionHistoryListSkeleton} from '@Components/version-history-list/components/version-history-list-skeleton';
import type {VersionHistoryListProps} from './version-history-list.types';
import styles from './version-history-list.module.scss';

function VersionHistoryList({versions, selectedIndex, isFetchingVersions, loadingIndex = null, onVersionSelect}: VersionHistoryListProps): ReactElement {
  const renderListContent = (): ReactElement | ReactElement[] => {
    if (isFetchingVersions) {
      return <VersionHistoryListSkeleton />;
    }

    return versions.map((version, index) => (
      <VersionHistoryListItem
        key={version.id}
        version={version}
        index={index}
        isSelected={index === selectedIndex}
        isLoading={loadingIndex === index}
        onVersionSelect={onVersionSelect}
      />
    ));
  };

  return (
    <ul className={`flexbox flex-column-justify-start gap-2 ${styles.versionHistoryList}`}>
      {renderListContent()}
    </ul>
  );
}

export default React.memo(VersionHistoryList);
